import { required, maxLength, minLength, numeric, integer, minValue, maxValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      walk_in: {
        customer_count: {
          required: helpers.withMessage(i18n.global.t('Please enter a specify number of guests.'), required),
          integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
          minValue: helpers.withMessage(i18n.global.t('Please enter a valid must be at least 1.'), minValue(1)),
          maxValue: helpers.withMessage(
            ({ $params }) => i18n.global.t('Number of guests cannot exceed') + ' ' + $params.max,
            maxValue(12)
          )
        }
      },
      reserve: {
        name: {
          required: helpers.withMessage(i18n.global.t('Please enter a customer name.'), required),
        },
        telephone: {
          required: helpers.withMessage(i18n.global.t('Please enter telephone'), required),
          numeric: helpers.withMessage(i18n.global.t('Telephone must be only numeric.'), numeric),
          minLength: helpers.withMessage(
            ({
              $params,
            }) => i18n.global.t('Telephone must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
            minLength(9)
          ),
          maxLength: helpers.withMessage(
            ({
              $params,
            }) => i18n.global.t('Telephone cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
            maxLength(10)
          ),
        },
        reserve_at: {
          required: helpers.withMessage(i18n.global.t('Please enter a started at.'), required),
        },
        pax: {
          required: helpers.withMessage(i18n.global.t('Please enter a number of guests.'), required),
          integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
          minValue: helpers.withMessage(i18n.global.t('Please enter a valid must be at least 1.'), minValue(1)),
          maxValue: helpers.withMessage(
            ({ $params }) => i18n.global.t('Number of guests cannot exceed') + ' ' + $params.max,
            maxValue(12)
          )
        },
        note: {}
      }
    }
  }
};
